var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ViewContainer',{staticClass:"top-banner",style:({ backgroundImage: `url(${_vm.bgImg})` })},[_c('ViewWrapper',[_c('div',{staticClass:"banner-wrapper"},[_c('div',{staticClass:"banner-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"banner-desc"},[_vm._t("default")],2)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }